const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function parseIsoDate(iso) {
  if (!iso) return null;
  const d = new Date(String(iso).includes('T') ? iso : `${iso}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Maps i18n language code to BCP 47 locale for date formatting. */
export function dateLocaleFromLang(lang) {
  return lang?.startsWith('vi') ? 'vi-VN' : 'en-GB';
}

/** "May 2026" / "tháng 5 năm 2026" — article cards, listing dates. */
export function formatMonthYear(iso, { empty = '—', locale } = {}) {
  if (!iso) return empty;
  const d = parseIsoDate(iso);
  if (!d) return String(iso);
  const loc = locale ? dateLocaleFromLang(locale) : 'en-GB';
  return d.toLocaleDateString(loc, { month: 'long', year: 'numeric' });
}

/** "22 May 2026" — admin article preview card. */
export function formatLongDateWithDay(iso) {
  if (!iso) return '—';
  const [y, m, d] = String(iso).split('-');
  if (!y || !m || !d) return String(iso);
  const month = MONTHS[parseInt(m, 10) - 1];
  if (!month) return String(iso);
  return `${parseInt(d, 10)} ${month} ${y}`;
}

/** Locale date + time — admin tables (e.g. account granted). */
export function formatDateTime(iso) {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return String(iso);
  }
}
